"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Twitter, Linkedin, Instagram, Facebook, Mail, Phone, MapPin } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-5 w-24 bg-muted animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3 text-sm text-muted-foreground">
        <li data-index={0}><Link to="#" className="hover:text-accent transition-colors">Accueil</Link></li>
        <li data-index={1}><Link to="#" className="hover:text-accent transition-colors">L'Agence</Link></li>
        <li data-index={2}><Link to="#" className="hover:text-accent transition-colors">Réalisations</Link></li>
        <li data-index={3}><Link to="#" className="hover:text-accent transition-colors">Contact</Link></li>
      </ul>;
  }
  return <ul className="space-y-3 text-sm">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-accent transition-colors duration-200">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function PiedDePage() {
  const services = ["Nice Centre & Vieux-Nice", "Villefranche-sur-Mer"];
  const currentYear = new Date().getFullYear();
  return <section data-section-id="205994" id="pied-de-page" className="bg-primary pt-16 pb-8 border-t border-border/10">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12 mb-12">
          
          {}
          <div className="flex flex-col items-start">
            <Link to="/HomePage#" className="inline-block mb-6">
              <img src="/img/creaweb_footer_logo.png" alt="D location" className="h-7 w-auto object-contain brightness-0 invert" />
            </Link>
            <p className="text-muted-foreground font-default text-sm leading-relaxed mb-6">
              D location est une conciergerie de prestige basée à Nice, dédiée à la gestion locative et l'intendance de propriétés d'exception sur la Côte d'Azur.
            </p>
            <div className="space-y-3 text-sm text-muted-foreground font-default">
              <div className="flex items-center gap-3">
                <MapPin className="size-4 text-accent shrink-0" />
                <span>20 Avenue Raymond Comboul,<br />&nbsp;06000 Nice</span>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="size-4 text-accent shrink-0" />
                <span>+33 6 45 66 56 57</span>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="size-4 text-accent shrink-0" />
                <span>dlocation.admin@gmail.com</span>
              </div>
            </div>
          </div>

          {}
          <div>
            <h3 className="font-default text-lg font-semibold text-primary-foreground mb-6">Navigation</h3>
            <MenuProvider menu_id="footer_menu">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default text-lg font-semibold text-primary-foreground mb-6">Secteurs d'Intervention</h3>
            <ul className="space-y-3 text-sm">
              {services.map((service, i) => <li key={i} data-index={i}>
                  <Link to="#" className="text-muted-foreground font-default hover:text-accent transition-colors duration-200 flex items-center gap-2">
                    <span className="h-1 w-1 rounded-full bg-accent/50"></span>
                    {service}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default text-lg font-semibold text-primary-foreground mb-6">Suivez l'Excellence</h3>
            <p className="text-muted-foreground font-default text-sm mb-6">
              Rejoignez-nous sur les réseaux sociaux pour découvrir nos propriétés exclusives et l'actualité de la Riviera.
            </p>
            <div className="flex flex-wrap gap-3">
              <Button variant="outline" size="icon" asChild className="rounded-none border-border/20 bg-transparent text-primary-foreground hover:bg-accent hover:text-accent-foreground hover:border-accent transition-all duration-300">
                <Link to="https://twitter.com" newTab aria-label="Twitter">
                  <Twitter className="size-4" />
                </Link>
              </Button>
              <Button variant="outline" size="icon" asChild className="rounded-none border-border/20 bg-transparent text-primary-foreground hover:bg-accent hover:text-accent-foreground hover:border-accent transition-all duration-300">
                <Link to="https://linkedin.com" newTab aria-label="LinkedIn">
                  <Linkedin className="size-4" />
                </Link>
              </Button>
              <Button variant="outline" size="icon" asChild className="rounded-none border-border/20 bg-transparent text-primary-foreground hover:bg-accent hover:text-accent-foreground hover:border-accent transition-all duration-300">
                <Link to="https://instagram.com" newTab aria-label="Instagram">
                  <Instagram className="size-4" />
                </Link>
              </Button>
              <Button variant="outline" size="icon" asChild className="rounded-none border-border/20 bg-transparent text-primary-foreground hover:bg-accent hover:text-accent-foreground hover:border-accent transition-all duration-300">
                <Link to="https://facebook.com" newTab aria-label="Facebook">
                  <Facebook className="size-4" />
                </Link>
              </Button>
            </div>
          </div>

        </div>

        <Separator className="mb-8 bg-border/10" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-muted-foreground font-default">
          <p>© {currentYear} D location. Tous droits réservés. Made in Nice.</p>
          <div className="flex items-center gap-6">
            <Link to="#" className="hover:text-primary-foreground transition-colors">Mentions légales</Link>
            <Link to="#" className="hover:text-primary-foreground transition-colors">Politique de confidentialité</Link>
          </div>
        </div>
      </div>
    </section>;
}